import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { THEME_BLACK_GOLD, THEME_TOP_WEDDING } from '@constant'
@observer
export default class extends Component {
  render() {
    const { brand, themeConfig, theme } = this.props.store
    return brand.length ? (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 13px',
          width: '100%',
          height: 52,
          marginBottom: -4,
          background:
            +theme === THEME_BLACK_GOLD || +theme === THEME_TOP_WEDDING
              ? themeConfig['bg']
              : '#fff'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            overflow: 'hidden'
          }}
        >
          <img
            style={{
              width: 13,
              height: 13,
              margin: '0 9px 0 0'
            }}
            src={themeConfig['honorIcon']}
          />
          <span
            style={{
              display: 'block',
              height: 18,
              fontSize: '13px',
              lineHeight: '18px',
              fontWeight: 500,
              borderRadius: 4,
              background:
                +theme === THEME_BLACK_GOLD || +theme === THEME_TOP_WEDDING
                  ? 'rgb(210, 156, 68)'
                  : themeConfig['theme'],
              color:
                +theme === THEME_BLACK_GOLD || +theme === THEME_TOP_WEDDING
                  ? '#000'
                  : '#fff',
              padding: '0 2px',
              marginRight: 12,
              flexShrink: 0
            }}
          >
            品牌认证
          </span>
          <span
            style={{
              maxWidth: '240px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              fontSize: '13px'
            }}
          >
            {brand.map(el => el.name).join('、')}
          </span>
        </div>
        <img
          style={{
            width: 6,
            height: 11,
            flexShrink: 0
          }}
          src="//qnm.hunliji.com/o_1cnbl9jkb1ed113b1oi1hb9g6f9.png"
        />
      </div>
    ) : null
  }
}
